import { canHost } from 'peer-sdk'
import { useEffect, useRef, useState } from 'react'
import { ChatIcon, TrashIcon } from './icons.tsx'
import { PARTICIPANT_COLORS, hashString } from './participantColors.js'
import './ConversationSidebar.css'

export const ConversationSidebar = ({
  conversations = [],
  activeConversationId,
  onSelect,
  onDelete,
  onCreate,
  contacts = [],
}: any) => {
  // Only LLM bots and chat workers can be hosts
  const hostContacts = contacts.filter((p: any) => canHost(p) && p.online)

  // Delete confirmation: track which conv is pending delete
  const [pendingDeleteId, setPendingDeleteId] = useState<string | null>(null)
  const timerRef = useRef<any>(null)

  // Auto-clear pending state after 3 seconds
  useEffect(() => {
    if (!pendingDeleteId) return
    timerRef.current = setTimeout(() => setPendingDeleteId(null), 3000)
    return () => clearTimeout(timerRef.current)
  }, [pendingDeleteId])

  const handleDelete = (e: any, convId: string) => {
    e.stopPropagation()
    if (pendingDeleteId === convId) {
      setPendingDeleteId(null)
      onDelete(convId)
    } else {
      setPendingDeleteId(convId)
    }
  }

  return (
    <div className="conv-list">
      {/* Conversation list */}
      {conversations.map((conv: any) => {
        const color = PARTICIPANT_COLORS[hashString(conv.hostRoleId) % PARTICIPANT_COLORS.length]
        const isActive = activeConversationId === conv.id
        const isPendingDelete = pendingDeleteId === conv.id
        return (
          <div key={conv.id} className={`conv-item${isActive ? ' conv-item-active' : ''}`}>
            <button className="conv-item-btn" onClick={() => onSelect(conv.id)}>
              <div
                className="conv-item-icon"
                style={{ background: `linear-gradient(135deg, ${color}22, ${color}11)` }}
              >
                <ChatIcon color={color} />
              </div>
              <div className="conv-item-info">
                <div className="conv-item-name">{conv.title || 'New conversation'}</div>
              </div>
            </button>
            {isPendingDelete ? (
              <button
                className="conv-item-delete conv-item-delete-confirm"
                onClick={e => handleDelete(e, conv.id)}
                title="Click again to confirm"
              >
                Delete?
              </button>
            ) : (
              <button
                className="conv-item-delete"
                onClick={e => handleDelete(e, conv.id)}
                title="Delete conversation"
              >
                <TrashIcon />
              </button>
            )}
          </div>
        )
      })}

      {conversations.length === 0 && (
        <div
          style={{
            padding: '16px',
            color: 'var(--text-dim)',
            fontSize: 'var(--font-size-sm)',
            textAlign: 'center',
          }}
        >
          No conversations yet
        </div>
      )}

      {/* New conversation buttons */}
      {hostContacts.length > 0 && (
        <div className="conv-new-section">
          <div className="conv-new-label">New chat with:</div>
          {hostContacts.map((p: any) => {
            const color = PARTICIPANT_COLORS[hashString(p.roleId) % PARTICIPANT_COLORS.length]
            return (
              <button key={p.roleId} className="conv-new-btn" onClick={() => onCreate(p)}>
                <span className="conv-new-dot" style={{ background: color }} />
                {p.displayName}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
